import React, { useContext, useEffect, useRef, useState } from 'react';
import { useT } from '../../../../../../helpers/i18n';
import useCollapse from 'react-collapsed';
import { config } from '@fortawesome/fontawesome-svg-core'
import { faSwimmingPool } from '@fortawesome/pro-regular-svg-icons'
import { faBed as fasBed, faHotTub as fasHotTub, faShower as fasShower, faUsers as fasUsers } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Checkers from '../../../../../../helpers/class/Checkers';
import Methods from '../../../../../../helpers/class/Methods';

import '@fortawesome/fontawesome-svg-core/styles.css'

config.autoAddCss = false;

import { useInViewport } from 'react-in-viewport';
import { useSelector } from 'react-redux';

import * as appContext from '../../../../../AppContext';
import ReadMoreText from '../../../../../ReadMoreText';

export default function DetailDesc ( props ) {
  const t = useT();
  const [ isPublicDomain, setIsPublicDomain ] = useState( useSelector( state => state['appSettings']['isPublicDomain']) )
  const [ publicDomain, setPublicDomain ] = useState( 0 );

  useEffect( () => {
    setPublicDomain( isPublicDomain )
  }, [ isPublicDomain, setPublicDomain ])
    
  const config = { disconnectOnLeave: false };
  const options = {  };
  const myRef = useRef();
  const {
    inViewport
  } = useInViewport(
    myRef,
    options,
    config,
    props
  );

  const array = [
    { key: 'guests', value: props.details.capacity },
    { key: 'bedrooms', value: props.details.bedrooms },
    { key: 'bathrooms', value: props.details.bathrooms },
    { key: 'pools', value: props.details.pools },
    { key: 'jacuzzi', value: props.details.jacuzzi },
  ];

  const [ isExpanded, setExpanded ] = React.useState( false );
  const { getCollapseProps } = useCollapse({
    isExpanded
  });

  const [ propertyTitle, setPropertyTitle ] = useState( props.details.property_title )

  const alternative_title = props.details.alternative_title

  const normalizeText = (text) => {
    if (!text) return '';

    return text
        .replace(/<[^>]*>/g, '')
        .replace(/&nbsp;/gi, ' ')
        .replace(/&amp;/gi, '&')
        .replace(/\s+/g, ' ')
        .trim();
  };

  const removeDescriptionFromBrief = (descBrief, description) => {
    if (!descBrief || !description) {
      return descBrief;
    }

    const normalizedDescription = normalizeText(description);

    let accumulatedText = '';
    let removeUntil = 0;

    const regex = /<p\b[^>]*>([\s\S]*?)<\/p>/gi;
    let match;

    while ((match = regex.exec(descBrief)) !== null) {
      const paragraphText = normalizeText(match[1]);

      if (!paragraphText) {
        continue;
      }

      accumulatedText = normalizeText(
          `${accumulatedText} ${paragraphText}`
      );

      // Τα paragraphs μέχρι στιγμής πρέπει να αποτελούν
      // την αρχή του description.
      if (!normalizedDescription.startsWith(accumulatedText)) {
        break;
      }

      removeUntil = regex.lastIndex;

      // Συμπληρώσαμε ακριβώς όλο το description.
      if (accumulatedText === normalizedDescription) {
        return descBrief.slice(removeUntil);
      }
    }

    return descBrief;
  };

  const descBrief = removeDescriptionFromBrief(
      props.details.desc_brief,
      props.details.description
  );

  useEffect( () => {
    if ( alternative_title != undefined && publicDomain==1 ) {
      if ( alternative_title.length>0 ) {
        setPropertyTitle( alternative_title )
      }
    }
  }, [ publicDomain, setPropertyTitle, alternative_title ])

  const b2description = props.details.b2b_description

  const isHtmlEmpty = (html) => {
    if (!html) return true

    const text = html.replace(/<[^>]*>/g, '').trim()
    return text === ''
  }
  
  const isPasswordProtectionEnabled = Checkers.valueToBoolean(props.passwordEnabled)

  let viewPortResult = null;

  viewPortResult =
    <>
      {
        publicDomain == 1 && props.details.whitelabel_description.length > 0 ?
          <>
            <ReadMoreText className={'text-md-justify'} lines={14} text={props.details.whitelabel_description } isDesktop={props.isDesktop}/>
          </>
          :
          <>

            <p className="text-justify">
              <strong>{props.details.motto}</strong>{Checkers.isValidString(props.details.motto) ? ". " : ""}{props.details.description}
            </p>
            <div {...getCollapseProps({})}>
              <>
                <div
                    dangerouslySetInnerHTML={{
                      __html: Methods.htmlTagReplacer(
                          descBrief,
                          'b',
                          'strong'
                      )
                    }}
                />
                <div dangerouslySetInnerHTML={{ __html: Methods.htmlTagReplacer( props.details.desc_details, 'b', 'strong' ) }}/>
              </>
            </div>
            {
              ( props.details.desc_brief.length > 0 || props.details.desc_details.length > 0 ) &&
              <p>
                <button className="btn-link text-link" onClick={() => setExpanded( ( value ) => !value )}>
                  {
                    isExpanded ? t('common.readLess') : t('property.overview')
                  }
                </button>
              </p>
            }
          </>

      }
    </>
  ;
  // }

  return (
    <div ref={myRef} id="pro_detail_desc" className="row full-width no-margin pb-5 test-class">
      { viewPortResult }
      {isPasswordProtectionEnabled && !isHtmlEmpty(b2description) ? <div dangerouslySetInnerHTML={{ __html: b2description }} /> : <></>}
    </div>
  )
}
